import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { ReportProblemButton } from '../components/ReportProblemModal';
import { STUDIO_COPY } from '../config';
import { useStudioDocumentTitle } from '../hooks/useStudioDocumentTitle';
import { listMyRttsSupportIssues } from '../support/rttsSupportApi';
import type { LscSupportIssue } from '../../lsc/types';
import { supportIssueCategoryLabel } from '../../lsc/supportIssueCopy';

const StudioMySupportPage: React.FC = () => {
  useStudioDocumentTitle('Support');
  const [issues, setIssues] = useState<LscSupportIssue[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listMyRttsSupportIssues()
      .then((rows) => {
        if (!cancelled) setIssues(rows);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Could not load reports');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="studio-panel space-y-4" data-testid="studio-my-support">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold">{STUDIO_COPY.myReportsTitle}</h1>
        <ReportProblemButton label={STUDIO_COPY.reportProblem} testId="studio-support-report" />
      </div>
      {error ? (
        <p className="text-red-300" role="alert">
          {error}
        </p>
      ) : null}
      {issues.length === 0 ? (
        <p className="text-[var(--studio-muted)]">No reports yet.</p>
      ) : (
        <ul className="space-y-3" data-testid="studio-my-support-list">
          {issues.map((issue) => (
            <li key={issue.issue_id}>
              <Link
                to={`/studio/support/${issue.issue_id}`}
                className="block rounded border border-white/10 p-3 no-underline"
              >
                <div className="flex justify-between gap-2">
                  <p className="font-medium text-white">{issue.title}</p>
                  <span className="text-xs uppercase tracking-wide text-[var(--studio-muted)]">
                    {issue.unread ? STUDIO_COPY.supportUnread : issue.status}
                  </span>
                </div>
                <p className="text-xs text-[var(--studio-muted)]">
                  {supportIssueCategoryLabel(issue.category)} · {issue.issue_id}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default StudioMySupportPage;
